import pako from 'pako'
import type { CustomPageLayout } from '@/views/apps/_customPage/types'

export const inflateLayout = (base64Gzip: string): CustomPageLayout => {
    const gzipped = Uint8Array.from(atob(base64Gzip), char => char.charCodeAt(0))

    return JSON.parse(pako.inflate(gzipped, { to: 'string' })) as CustomPageLayout
}
